Object.defineProperty(exports, '__esModule', { value: true });

var LRUCache = require('lru-cache');
var _ = require('lodash');
var elliptic = require('elliptic');
var CryptoJS = require('crypto-js');
var SecureLS = require('secure-ls');
var useAxios = require('axios-hooks');
var React = require('react');
var reactUse = require('react-use');
var Fingerprint2 = require('fingerprintjs2');
var uuid = require('uuid');
var reactRouterDom = require('react-router-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var LRUCache__default = /*#__PURE__*/_interopDefaultLegacy(LRUCache);
var ___default = /*#__PURE__*/_interopDefaultLegacy(_);
var CryptoJS__default = /*#__PURE__*/_interopDefaultLegacy(CryptoJS);
var SecureLS__default = /*#__PURE__*/_interopDefaultLegacy(SecureLS);
var useAxios__default = /*#__PURE__*/_interopDefaultLegacy(useAxios);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Fingerprint2__default = /*#__PURE__*/_interopDefaultLegacy(Fingerprint2);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function encode(val) {
    return encodeURIComponent(val)
        .replace(/%3A/gi, ":")
        .replace(/%24/g, "$")
        .replace(/%2C/gi, ",")
        .replace(/%20/g, "+")
        .replace(/%5B/gi, "[")
        .replace(/%5D/gi, "]");
}
function isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
function buildCacheUrl(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/
    if (!params) {
        return url;
    }
    var serializedParams;
    if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
    }
    else if (isURLSearchParams(params)) {
        serializedParams = params.toString();
    }
    else {
        var parts = [];
        ___default["default"].forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") {
                return;
            }
            if (___default["default"].isArray(val)) {
                key = key + "[]";
            }
            else {
                val = [val];
            }
            ___default["default"].forEach(val, function parseValue(v) {
                if (___default["default"].isDate(v)) {
                    v = v.toISOString();
                }
                else if (___default["default"].isObject(v)) {
                    v = JSON.stringify(v);
                }
                parts.push(encode(key) + "=" + encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) {
            url = url.slice(0, hashmarkIndex);
        }
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

function buildCacheKey(url, params, paramsSerializer, method, data) {
    var cacheKey = buildSortedURL(url || "", params, paramsSerializer);
    if (!!data) {
        cacheKey += "|" + (method || "") + "|" + (data || "");
    }
    return cacheKey;
}
function buildSortedURL(url, params, paramsSerializer) {
    var builtURL = buildCacheUrl(url, params, paramsSerializer);
    var _a = builtURL.split("?"), urlPath = _a[0], queryString = _a[1];
    if (queryString) {
        var paramsPair = queryString.split("&");
        return urlPath + "?" + paramsPair.sort().join("&");
    }
    return builtURL;
}

var FIVE_MINUTES = 1000 * 60 * 5;
var CAPACITY = 100;
function cacheAdapterEnhancer(adapter, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _a = options.cacheFlag, cacheFlag = _a === void 0 ? "cache" : _a, _b = options.clearCacheFlag, clearCacheFlag = _b === void 0 ? "clearCache" : _b, _c = options.cacheNameFlag, cacheNameFlag = _c === void 0 ? "cacheName" : _c, _d = options.defaultCache, defaultCache = _d === void 0 ? new LRUCache__default["default"]({
        maxAge: FIVE_MINUTES,
        max: CAPACITY,
    }) : _d;
    return function (config) {
        var url = config.url, method = config.method, params = config.params, paramsSerializer = config.paramsSerializer, data = config.data, forceUpdate = config.forceUpdate;
        var useCache = config[cacheFlag] !== void 0 && config[cacheFlag] !== null && config[cacheFlag];
        var clearCache = config[clearCacheFlag] !== void 0 &&
            config[clearCacheFlag] !== null &&
            config[clearCacheFlag];
        var cacheName = config[cacheNameFlag] !== void 0 &&
            config[cacheNameFlag] !== null &&
            config[cacheNameFlag];
        if (clearCache && cacheName) {
            defaultCache.keys().forEach(function (key) {
                var value = defaultCache.peek(key);
                if (value && value.cacheName === cacheName) {
                    defaultCache.del(key);
                }
            });
        }
        if (useCache) {
            // build the cache key according to the url and params
            var cacheKey_1 = buildCacheKey(url, params, paramsSerializer, method, data);
            var cacheValue = defaultCache.get(cacheKey_1);
            var responsePromise = cacheValue === null || cacheValue === void 0 ? void 0 : cacheValue.responsePromise;
            if (!responsePromise || forceUpdate) {
                responsePromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var reason_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, adapter(config)];
                            case 1: return [2 /*return*/, _a.sent()];
                            case 2:
                                reason_1 = _a.sent();
                                defaultCache.del(cacheKey_1);
                                throw reason_1;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); })();
                // put the promise for the non-transformed response into cache as a placeholder
                defaultCache.set(cacheKey_1, {
                    responsePromise: responsePromise,
                    cacheName: cacheName,
                });
                return responsePromise;
            }
            return responsePromise;
        }
        return adapter(config);
    };
}

var PARAM_FINGERPRINT = "PARAM_FINGERPRINT";
var PARAM_UPDATE_PACKS = "PARAM_UPDATE_PACKS";
var PARAM_CLIENT_PRIVATE_KEY = "PARAM_CLIENT_PRIVATE_KEY";
var PARAM_CLIENT_PUBLIC_KEY = "PARAM_CLIENT_PUBLIC_KEY";
var PARAM_REMOTE_STORAGE_LAST_UPDATE_TIME = "PARAM_REMOTE_STORAGE_LAST_UPDATE_TIME";
var PARAM_REMOTE_STORAGE_VALUES = "PARAM_REMOTE_STORAGE_VALUES";
var PARAM_REMOTE_STORAGE_VALUES_TO_SAVE = "PARAM_REMOTE_STORAGE_VALUES_TO_SAVE";
var PARAM_REMOTE_STORAGE_IDENTIFIERS_TO_DELETE = "PARAM_REMOTE_STORAGE_IDENTIFIERS_TO_DELETE";

var securedLS;
var cache = {};
var LocalStorageWrapper = {
    getLocalStorage: function () {
        if (!securedLS) {
            securedLS = new SecureLS__default["default"]({ encodingType: "aes" });
        }
        return securedLS;
    },
    get: function (key) {
        if (___default["default"].has(cache, key)) {
            return cache[key];
        }
        var ls = this.getLocalStorage();
        var value = undefined;
        if (ls.getAllKeys().includes(key)) {
            try {
                value = ls.get(key);
            }
            catch (e) { }
        }
        cache[key] = value;
        return value;
    },
    set: function (key, value) {
        var ls = this.getLocalStorage();
        ls.set(key, value);
        cache[key] = value;
    },
    remove: function (key) {
        var ls = this.getLocalStorage();
        ls.remove(key);
        delete cache[key];
    },
    clear: function () {
        var ls = this.getLocalStorage();
        ls.clear();
        cache = {};
    },
};

var EncryptionUtils = {
    ec: new elliptic.ec("secp256k1"),
    generateClientKeyPair: function () {
        var keyPair = this.ec.genKeyPair();
        var base64PrivateKey = Buffer.from(keyPair.getPrivate("hex"), "hex").toString("base64");
        var base64PublicKey = Buffer.from(keyPair.getPublic("array")).toString("base64");
        LocalStorageWrapper.set(PARAM_CLIENT_PRIVATE_KEY, base64PrivateKey);
        LocalStorageWrapper.set(PARAM_CLIENT_PUBLIC_KEY, base64PublicKey);
    },
    clearClientKeyPair: function () {
        LocalStorageWrapper.remove(PARAM_CLIENT_PRIVATE_KEY);
        LocalStorageWrapper.remove(PARAM_CLIENT_PUBLIC_KEY);
    },
    getClientPrivateKeyBase64: function () {
        var clientPrivateKey = LocalStorageWrapper.get(PARAM_CLIENT_PRIVATE_KEY);
        if (!!clientPrivateKey) {
            return clientPrivateKey;
        }
        this.generateClientKeyPair();
        return LocalStorageWrapper.get(PARAM_CLIENT_PRIVATE_KEY);
    },
    getClientPublicKeyBase64: function () {
        var clientPublicKey = LocalStorageWrapper.get(PARAM_CLIENT_PUBLIC_KEY);
        if (!!clientPublicKey) {
            return clientPublicKey;
        }
        this.generateClientKeyPair();
        return LocalStorageWrapper.get(PARAM_CLIENT_PUBLIC_KEY);
    },
    getClientKeyPair: function () {
        var clientPrivateKey = Buffer.from(this.getClientPrivateKeyBase64(), "base64");
        return this.ec.keyFromPrivate(clientPrivateKey);
    },
    getServerKeyPair: function (serverPublicKeyBase64) {
        var serverPublicKey = Buffer.from(serverPublicKeyBase64, "base64");
        return this.ec.keyFromPublic(serverPublicKey);
    },
    getDerivedKey: function (serverPublicKeyBase64) {
        var clientKeyPair = this.getClientKeyPair();
        var serverKeyPair = this.getServerKeyPair(serverPublicKeyBase64);
        return clientKeyPair.derive(serverKeyPair.getPublic());
    },
    getEmptyIV: function () {
        return CryptoJS__default["default"].enc.Hex.parse("00000000000000000000000000000000");
    },
    decrypt: function (serverPublicKeyBase64, cipherTextBase64) {
        var derivedKey = this.getDerivedKey(serverPublicKeyBase64);
        var decrypted = CryptoJS__default["default"].AES.decrypt(cipherTextBase64, CryptoJS__default["default"].enc.Hex.parse(derivedKey.toString(16)), {
            iv: this.getEmptyIV(),
        });
        return decrypted.toString(CryptoJS__default["default"].enc.Utf8);
    },
    encrypt: function (serverPublicKeyBase64, data) {
        var derivedKey = this.getDerivedKey(serverPublicKeyBase64);
        var dataString = ___default["default"].isString(data) ? data : JSON.stringify(data);
        var encrypted = CryptoJS__default["default"].AES.encrypt(dataString, CryptoJS__default["default"].enc.Hex.parse(derivedKey.toString(16)), {
            iv: this.getEmptyIV(),
        });
        return encrypted.toString();
    },
};

var CLIENT_PUBLIC_KEY_HEADER = "x-client-public-key";
var SERVER_PUBLIC_KEY_HEADER = "x-server-public-key";
var SERVER_PUBLIC_KEY_PARAM = "p64ifAFDkBzL86uG1";
function encryptionAdapterEnhancer(adapter, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _a = options.encryptionFlag, encryptionFlag = _a === void 0 ? "encrypt" : _a;
    var sendRequestWithEncryption = function (config) {
        return (function () { return __awaiter(_this, void 0, void 0, function () {
            var data, headers, serverPublicKey, response, encryptedRequest, updatedData, encryptionHeaders, updatedHeaders, responseServerPublicKey, decryptedData;
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        data = config.data, headers = config.headers;
                        serverPublicKey = localStorage.getItem(SERVER_PUBLIC_KEY_PARAM);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 5]);
                        updatedData = !!data && !!serverPublicKey ? EncryptionUtils.encrypt(serverPublicKey, data) : data;
                        encryptionHeaders = (_a = {}, _a[CLIENT_PUBLIC_KEY_HEADER] = EncryptionUtils.getClientPublicKeyBase64(), _a);
                        updatedHeaders = headers ? __assign(__assign({}, headers), encryptionHeaders) : encryptionHeaders;
                        return [4 /*yield*/, adapter(__assign(__assign({}, config), { data: updatedData, headers: updatedHeaders }))];
                    case 2:
                        response = _c.sent();
                        encryptedRequest = true;
                        return [3 /*break*/, 5];
                    case 3:
                        _c.sent();
                        console.warn("Client SSL Encryption failed.", serverPublicKey);
                        return [4 /*yield*/, adapter(config)];
                    case 4:
                        response = _c.sent();
                        encryptedRequest = false;
                        return [3 /*break*/, 5];
                    case 5:
                        responseServerPublicKey = (_b = response.headers) === null || _b === void 0 ? void 0 : _b[SERVER_PUBLIC_KEY_HEADER];
                        if (!!responseServerPublicKey) {
                            localStorage.setItem(SERVER_PUBLIC_KEY_PARAM, responseServerPublicKey);
                        }
                        if (encryptedRequest && response.data) {
                            decryptedData = EncryptionUtils.decrypt(serverPublicKey || responseServerPublicKey, response.data);
                            return [2 /*return*/, __assign(__assign({}, response), { data: decryptedData })];
                        }
                        return [2 /*return*/, response];
                }
            });
        }); })();
    };
    return function (config) {
        var useEncryption = config[encryptionFlag] !== void 0 &&
            config[encryptionFlag] !== null &&
            config[encryptionFlag];
        if (!useEncryption) {
            return adapter(config);
        }
        var serverPublicKey = localStorage.getItem(SERVER_PUBLIC_KEY_PARAM);
        var canEncrypt = !config.data || !!serverPublicKey;
        if (!canEncrypt) {
            return adapter(config);
        }
        return sendRequestWithEncryption(config);
    };
}

function throttleAdapterEnhancer(adapter, options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _a = options.threshold, threshold = _a === void 0 ? 1000 : _a, _b = options.throttleFlag, throttleFlag = _b === void 0 ? "throttle" : _b, _c = options.cache, cache = _c === void 0 ? new LRUCache__default["default"]({ max: 10 }) : _c;
    var recordCacheWithRequest = function (index, config) {
        var responsePromise = (function () { return __awaiter(_this, void 0, void 0, function () {
            var response, reason_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, adapter(config)];
                    case 1:
                        response = _a.sent();
                        cache.set(index, {
                            timestamp: Date.now(),
                            value: Promise.resolve(response),
                        });
                        return [2 /*return*/, response];
                    case 2:
                        reason_1 = _a.sent();
                        cache.del(index);
                        throw reason_1;
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
        cache.set(index, {
            timestamp: Date.now(),
            value: responsePromise,
        });
        return responsePromise;
    };
    return function (config) {
        var url = config.url, method = config.method, params = config.params, paramsSerializer = config.paramsSerializer, data = config.data;
        var useThrottle = config[throttleFlag] !== void 0 &&
            config[throttleFlag] !== null &&
            config[throttleFlag];
        if (useThrottle) {
            // build the cache key according to the url and params
            var cacheKey = buildCacheKey(url, params, paramsSerializer, method, data);
            var now = Date.now();
            var cachedRecord = cache.get(cacheKey) || { timestamp: now };
            if (now - cachedRecord.timestamp <= threshold) {
                var responsePromise = cachedRecord.value;
                if (responsePromise) {
                    return responsePromise;
                }
            }
            return recordCacheWithRequest(cacheKey, config);
        }
        return adapter(config);
    };
}

var useGlobalClearedCacheName = reactUse.createGlobalState(undefined);
function useGenericRequest(config, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.manual, manual = _c === void 0 ? true : _c, _d = _b.cache, cache = _d === void 0 ? false : _d, _e = _b.clearCache, clearCache = _e === void 0 ? false : _e, cacheName = _b.cacheName, _f = _b.cacheAutoReload, cacheAutoReload = _f === void 0 ? false : _f, _g = _b.throttle, throttle = _g === void 0 ? false : _g, _h = _b.autoCancel, autoCancel = _h === void 0 ? true : _h, _j = _b.encrypt, encrypt = _j === void 0 ? false : _j, _k = _b.timeout, timeout = _k === void 0 ? 0 : _k, resultTransformer = _b.resultTransformer, successTransformer = _b.successTransformer;
    var _l = React.useState(undefined), requestConfig = _l[0], setRequestConfig = _l[1];
    var _m = React.useState(undefined), pendingRequestConfig = _m[0], setPendingRequestConfig = _m[1];
    var _o = useGlobalClearedCacheName(), clearedCacheName = _o[0], setClearedCacheName = _o[1];
    var _p = React.useState(undefined), result = _p[0], setResult = _p[1];
    var _q = React.useState(false), loading = _q[0], setLoading = _q[1];
    var _r = React.useState(undefined), error = _r[0], setError = _r[1];
    var _s = React.useState(false), executed = _s[0], setExecuted = _s[1];
    var _t = useAxios__default["default"]({
        url: (requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.url) || "",
        method: (requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.method) || "GET",
        data: requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.data,
        headers: requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.headers,
        responseType: requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.responseType,
        cache: cache,
        clearCache: clearCache,
        cacheName: cacheName,
        throttle: throttle,
        encrypt: encrypt,
        timeout: timeout,
        onUploadProgress: requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.onUploadProgress,
    }, { manual: true }), _u = _t[0], responseData = _u.data, requestLoading = _u.loading, serverError = _u.error, executeAxiosRequest = _t[1], manualCancel = _t[2];
    React.useEffect(function () {
        if (!manual && config) {
            executeRequest();
        }
    }, [manual]);
    reactUse.useUpdateEffect(function () {
        if (!manual &&
            config &&
            requestConfig &&
            !___default["default"].isEqual(config, requestConfig) &&
            !___default["default"].isEqual(config, pendingRequestConfig)) {
            executeRequest();
        }
    }, [config]);
    React.useEffect(function () {
        if (!responseData) {
            return;
        }
        setLoading(false);
        var success = successTransformer ? successTransformer(responseData) : responseData.success;
        if (success) {
            setResult(resultTransformer ? resultTransformer(responseData) : responseData.result);
            setExecuted(true);
            setError(undefined);
            if (clearCache && cacheName) {
                setClearedCacheName({ cacheName: cacheName });
            }
        }
        else {
            setResult(undefined);
            setError(responseData.error || true);
        }
    }, [responseData]);
    React.useEffect(function () {
        if (requestConfig) {
            setResult(undefined);
            setLoading(true);
            setError(undefined);
            setExecuted(false);
            executeAxiosRequest().catch(function (error) { return setError(error); });
        }
    }, [requestConfig]);
    var executeRequest = React.useCallback(function () {
        if (!config) {
            return;
        }
        if (loading) {
            setPendingRequestConfig(config);
        }
        else {
            setRequestConfig(__assign({}, config));
        }
    }, [config, loading, setPendingRequestConfig, setRequestConfig]);
    reactUse.useUpdateEffect(function () {
        if (!loading && pendingRequestConfig) {
            setRequestConfig(__assign({}, pendingRequestConfig));
            setPendingRequestConfig(undefined);
        }
    }, [loading]);
    var cancelRequest = React.useCallback(function () {
        manualCancel();
    }, [manualCancel]);
    React.useEffect(function () {
        return function () {
            if (autoCancel) {
                manualCancel();
            }
        };
    }, []);
    React.useEffect(function () {
        setLoading(requestLoading);
    }, [requestLoading]);
    React.useEffect(function () {
        if (serverError) {
            setError(serverError);
        }
    }, [serverError]);
    reactUse.useUpdateEffect(function () {
        if (cache && cacheAutoReload && cacheName && clearedCacheName) {
            if (cacheName === clearedCacheName.cacheName) {
                executeRequest();
            }
        }
    }, [clearedCacheName]);
    return { result: result, loading: loading, error: error, executed: executed, executeRequest: executeRequest, cancelRequest: cancelRequest };
}

function useGenericRequestMany(config, options) {
    if (options === void 0) { options = {}; }
    var _a = React.useState(undefined), successful = _a[0], setSuccessful = _a[1];
    var _b = React.useState(undefined), failed = _b[0], setFailed = _b[1];
    var _c = React.useState(false), executed = _c[0], setExecuted = _c[1];
    var _d = useGenericRequest(config, options), result = _d.result, loading = _d.loading, error = _d.error, executeRequest = _d.executeRequest, cancelRequest = _d.cancelRequest;
    React.useEffect(function () {
        if (result) {
            setExecuted(true);
            setSuccessful(result.successful);
            setFailed(result.failed);
        }
    }, [result]);
    return { successful: successful, failed: failed, loading: loading, error: error, executed: executed, executeRequest: executeRequest, cancelRequest: cancelRequest };
}

function useGenericRequestUpload(file, url, data) {
    var _a = React.useState(0), progress = _a[0], setProgress = _a[1];
    var _b = React.useState(undefined), formData = _b[0], setFormData = _b[1];
    var _c = useGenericRequest({
        url: url,
        method: "POST",
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress: function (progressEvent) {
            if (!progressEvent || !progressEvent.total) {
                return;
            }
            setProgress(Math.floor((progressEvent.loaded / progressEvent.total) * 100));
        },
    }, {
        manual: true,
    }), result = _c.result, loading = _c.loading, error = _c.error, executed = _c.executed, executeRequestInternal = _c.executeRequest, cancelRequest = _c.cancelRequest;
    var executeRequest = React.useCallback(function () {
        if (!file) {
            return;
        }
        setProgress(0);
        var fileFormData = new FormData();
        fileFormData.append("file", file);
        fileFormData.append("alias", file.name);
        fileFormData.append("type", "File");
        if (data) {
            ___default["default"].forEach(data, function (value, key) {
                fileFormData.append(key, value);
            });
        }
        setFormData(fileFormData);
    }, [file, data, setProgress, setFormData]);
    React.useEffect(function () {
        if (formData) {
            executeRequestInternal();
        }
    }, [formData]);
    return { result: result, loading: loading, error: error, executed: executed, progress: progress, executeRequest: executeRequest, cancelRequest: cancelRequest };
}

function useCrudCreate(entity, dataItem, options) {
    if (options === void 0) { options = {
        encrypt: false,
    }; }
    return useGenericRequest({
        url: "" + entity.api.path,
        method: "POST",
        data: dataItem,
    }, {
        manual: true,
        clearCache: true,
        cacheName: entity.api.cacheName,
        encrypt: options === null || options === void 0 ? void 0 : options.encrypt,
    });
}

function useCrudCreateMany(entity, createItems, options) {
    if (options === void 0) { options = {
        encrypt: false,
    }; }
    return useGenericRequestMany({
        url: entity.api.path + "/many",
        method: "POST",
        data: createItems,
    }, {
        manual: true,
        clearCache: true,
        cacheName: entity.api.cacheName,
        encrypt: options === null || options === void 0 ? void 0 : options.encrypt,
    });
}

function useCrudUpdate(entity, dataItem, options) {
    if (options === void 0) { options = {
        encrypt: false,
    }; }
    return useGenericRequest({
        url: entity.api.path + "/" + (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id),
        method: "PUT",
        data: dataItem,
    }, {
        manual: true,
        clearCache: true,
        cacheName: entity.api.cacheName,
        encrypt: options === null || options === void 0 ? void 0 : options.encrypt,
    });
}

function useCrudCreateOrUpdate(entity, dataItem, options) {
    if (options === void 0) { options = {
        encrypt: false,
    }; }
    var _a = React.useState(undefined), requestItem = _a[0], setRequestItem = _a[1];
    var _b = React.useState(undefined), pendingRequestItem = _b[0], setPendingRequestItem = _b[1];
    var _c = React.useState(undefined), result = _c[0], setResult = _c[1];
    var _d = React.useState(false), loading = _d[0], setLoading = _d[1];
    var _e = React.useState(undefined), error = _e[0], setError = _e[1];
    var _f = React.useState(false), executed = _f[0], setExecuted = _f[1];
    React.useEffect(function () {
        if (requestItem) {
            if (___default["default"].isNumber(requestItem.id) && requestItem.id > 0) {
                updateState.executeRequest();
            }
            else {
                createState.executeRequest();
            }
        }
    }, [requestItem]);
    var createState = useCrudCreate(entity, requestItem, options);
    var updateState = useCrudUpdate(entity, requestItem, options);
    React.useEffect(function () {
        if (createState.result) {
            setResult(createState.result);
            setError(undefined);
        }
    }, [createState.result]);
    React.useEffect(function () {
        if (updateState.result) {
            setResult(updateState.result);
            setError(undefined);
        }
    }, [updateState.result]);
    var executeRequestInternal = React.useCallback(function (requestItem) {
        setRequestItem(requestItem);
        setLoading(true);
    }, [setRequestItem, setLoading]);
    var executeRequest = React.useCallback(function () {
        if (loading || pendingRequestItem) {
            setPendingRequestItem(dataItem);
        }
        else {
            executeRequestInternal(dataItem);
        }
    }, [dataItem, loading, pendingRequestItem, setPendingRequestItem, executeRequestInternal]);
    var cancelRequest = React.useCallback(function () {
        if (createState.loading) {
            createState.cancelRequest();
        }
        if (updateState.loading) {
            updateState.cancelRequest();
        }
    }, [createState, updateState]);
    React.useEffect(function () {
        if (!loading && pendingRequestItem) {
            executeRequestInternal(pendingRequestItem);
            setPendingRequestItem(undefined);
        }
    }, [loading]);
    React.useEffect(function () {
        setLoading((createState && createState.loading) || (updateState && updateState.loading));
    }, [createState.loading, updateState.loading]);
    React.useEffect(function () {
        setError(createState && createState.error);
    }, [createState.error]);
    React.useEffect(function () {
        setError(updateState && updateState.error);
    }, [updateState.error]);
    React.useEffect(function () {
        setExecuted(createState.executed || updateState.executed);
    }, [createState.executed, updateState.executed]);
    return { result: result, loading: loading, error: error, executed: executed, executeRequest: executeRequest, cancelRequest: cancelRequest };
}

function useCrudCreateOrUpdateMany(entity, items, options) {
    if (options === void 0) { options = {
        encrypt: false,
    }; }
    return useGenericRequestMany({
        url: entity.api.path + "/createOrUpdate/many",
        method: "POST",
        data: items,
    }, {
        manual: true,
        clearCache: true,
        cacheName: entity.api.cacheName,
        encrypt: options === null || options === void 0 ? void 0 : options.encrypt,
    });
}

function useCrudDelete(entity, id) {
    return useGenericRequest({
        url: entity.api.path + "/" + id,
        method: "DELETE",
    }, {
        manual: true,
        clearCache: true,
        cacheName: entity.api.cacheName,
        resultTransformer: function (responseData) { return responseData.success; },
    });
}

function useCrudDeleteMany(entity, ids) {
    return useGenericRequestMany({
        url: entity.api.path + "/many",
        method: "DELETE",
        data: ids,
    }, {
        manual: true,
        clearCache: true,
        cacheName: entity.api.cacheName,
    });
}

function useCrudSearch(entity, currentPage, pageSize, filterFields, orders, options) {
    if (options === void 0) { options = {
        manual: false,
        count: true,
        cache: false,
        throttle: false,
        cacheAutoReload: false,
        encrypt: false,
    }; }
    var _a = React.useState([]), items = _a[0], setItems = _a[1];
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState(0), totalItemCount = _c[0], setTotalItemCount = _c[1];
    var _d = React.useState(1), totalPageCount = _d[0], setTotalPageCount = _d[1];
    var _e = React.useState(true), hasMore = _e[0], setHasMore = _e[1];
    var start = (currentPage - 1) * pageSize;
    var limit = pageSize;
    var countState = useGenericRequest({
        url: entity.api.path + "/search/count",
        method: "POST",
        data: {
            filterFields: filterFields,
        },
    }, {
        manual: (options === null || options === void 0 ? void 0 : options.manual) || !(options === null || options === void 0 ? void 0 : options.count),
        cache: options === null || options === void 0 ? void 0 : options.cache,
        cacheName: entity.api.cacheName,
        cacheAutoReload: (options === null || options === void 0 ? void 0 : options.cacheAutoReload) && (options === null || options === void 0 ? void 0 : options.count),
        throttle: options === null || options === void 0 ? void 0 : options.throttle,
        encrypt: options === null || options === void 0 ? void 0 : options.encrypt,
        resultTransformer: function (responseData) { return responseData; },
    });
    React.useEffect(function () {
        var data = countState.result;
        if (data && data.success) {
            var count = data.result;
            setTotalItemCount(count);
            setTotalPageCount(Math.max(1, Math.ceil(count / pageSize)));
        }
    }, [countState.result]);
    React.useEffect(function () {
        if (totalItemCount) {
            setTotalPageCount(Math.max(1, Math.ceil(totalItemCount / pageSize)));
        }
    }, [pageSize]);
    var searchState = useGenericRequest({
        url: entity.api.path + "/search",
        method: "POST",
        data: {
            start: start,
            limit: limit,
            filterFields: filterFields,
            orders: orders,
        },
    }, {
        manual: options === null || options === void 0 ? void 0 : options.manual,
        cache: options === null || options === void 0 ? void 0 : options.cache,
        cacheName: entity.api.cacheName,
        cacheAutoReload: options === null || options === void 0 ? void 0 : options.cacheAutoReload,
        throttle: options === null || options === void 0 ? void 0 : options.throttle,
        resultTransformer: function (responseData) { return responseData; },
    });
    React.useEffect(function () {
        var data = searchState.result;
        if (data) {
            if (data.success) {
                setItems(data.result);
                setHasMore(data.paging.hasMore || data.paging.start + data.paging.limit < data.paging.total);
                if (!(options === null || options === void 0 ? void 0 : options.count)) {
                    setTotalItemCount(data.paging.total || data.paging.start + data.result.length || 0);
                }
            }
            else {
                setHasMore(false);
            }
        }
    }, [searchState.result]);
    React.useEffect(function () {
        if (searchState.error) {
            setHasMore(false);
        }
    }, [searchState.error]);
    React.useEffect(function () {
        setLoading(searchState.loading || countState.loading);
    }, [searchState.loading, countState.loading]);
    var executeRequest = React.useCallback(function () {
        setLoading(true);
        if (options === null || options === void 0 ? void 0 : options.count) {
            countState.executeRequest();
        }
        searchState.executeRequest();
    }, [countState, countState.executeRequest, searchState.executeRequest, setLoading]);
    var cancelRequest = React.useCallback(function () {
        setLoading(false);
        countState.cancelRequest();
        searchState.cancelRequest();
    }, [countState.cancelRequest, searchState.cancelRequest]);
    return {
        result: items,
        totalItemCount: totalItemCount,
        totalPageCount: totalPageCount,
        hasMore: hasMore,
        loading: loading,
        error: searchState.error,
        executed: searchState.executed,
        executeRequest: executeRequest,
        cancelRequest: cancelRequest,
    };
}

function useCrudSearchCount(entity, filterFields, options) {
    if (options === void 0) { options = {
        manual: false,
        cache: false,
        throttle: false,
        encrypt: false,
    }; }
    return useGenericRequest({
        url: entity.api.path + "/search/count",
        method: "POST",
        data: {
            filterFields: filterFields,
        },
    }, {
        manual: options === null || options === void 0 ? void 0 : options.manual,
        cache: options === null || options === void 0 ? void 0 : options.cache,
        cacheName: entity.api.cacheName,
        throttle: options === null || options === void 0 ? void 0 : options.throttle,
        encrypt: options === null || options === void 0 ? void 0 : options.encrypt,
    });
}

function useCrudShow(entity, id, options) {
    if (options === void 0) { options = {
        manual: false,
        cache: false,
        throttle: false,
        encrypt: false,
    }; }
    return useGenericRequest({
        url: entity.api.path + "/" + id,
        method: "GET",
    }, {
        manual: (options === null || options === void 0 ? void 0 : options.manual) || !id,
        cache: options === null || options === void 0 ? void 0 : options.cache,
        cacheName: entity.api.cacheName,
        throttle: options === null || options === void 0 ? void 0 : options.throttle,
        encrypt: options === null || options === void 0 ? void 0 : options.encrypt,
    });
}

function useCrudUpdateMany(entity, updateItems, options) {
    if (options === void 0) { options = {
        encrypt: false,
    }; }
    return useGenericRequestMany({
        url: entity.api.path + "/many",
        method: "PUT",
        data: updateItems,
    }, {
        manual: true,
        clearCache: true,
        cacheName: entity.api.cacheName,
        encrypt: options === null || options === void 0 ? void 0 : options.encrypt,
    });
}

function useMediaFileDeleteEntity(entity, entityId, columnName) {
    return useGenericRequest({
        url: "/mediaFile/deleteAssociatedMediaFile/" + entityId + "/" + entity.name + "/" + columnName,
        method: "DELETE",
    }, {
        manual: true,
        clearCache: true,
        cacheName: entity.api.cacheName,
        resultTransformer: function (responseData) { return responseData.success; },
    });
}

function useMediaFileDownload(fileUuid, options) {
    if (options === void 0) { options = {
        manual: false,
    }; }
    return useGenericRequest({
        url: "/mediaFile/download/" + fileUuid,
        method: "GET",
        responseType: "blob",
    }, {
        manual: options.manual,
        cache: true,
        throttle: true,
        resultTransformer: function (responseData) { return responseData; },
        successTransformer: function (responseData) { return !!responseData; },
    });
}

function useMediaFileUpload(file, options) {
    var url = React.useMemo(function () { return "/mediaFile/upload"; }, []);
    var data = React.useMemo(function () { return ({ aclMode: (options === null || options === void 0 ? void 0 : options.acl) || "PRIVATE" }); }, [options]);
    return useGenericRequestUpload(file, url, data);
}

function useMediaFileUploadEntity(file, entity, entityId, columnName) {
    var url = React.useMemo(function () { return "/mediaFile/uploadAndAssociate/" + entityId + "/" + entity.name + "/" + columnName; }, [entity, entityId, columnName]);
    return useGenericRequestUpload(file, url);
}

var useLocalStorageState = function (key, initialState, options) {
    if (options === void 0) { options = { encrypted: true }; }
    var _a = React.useState(function () {
        if (options.encrypted) {
            var valueItem = LocalStorageWrapper.get(key);
            if (!___default["default"].isNil(valueItem)) {
                return valueItem;
            }
        }
        else {
            var valueItemString = localStorage.getItem(key);
            if (!___default["default"].isNil(valueItemString)) {
                return JSON.parse(valueItemString);
            }
        }
        return ___default["default"].isFunction(initialState) ? initialState() : initialState;
    }), item = _a[0], setInnerValue = _a[1];
    var setValue = function (value) {
        setInnerValue(function (currentInnerValue) {
            var valueToStore = ___default["default"].isFunction(value) ? value(currentInnerValue) : value;
            if (!___default["default"].isNil(valueToStore)) {
                if (options.encrypted) {
                    LocalStorageWrapper.set(key, valueToStore);
                }
                else {
                    localStorage.setItem(key, JSON.stringify(valueToStore));
                }
            }
            else {
                if (options.encrypted) {
                    LocalStorageWrapper.remove(key);
                }
                else {
                    localStorage.removeItem(key);
                }
            }
            return valueToStore;
        });
    };
    return [item, setValue];
};

var remoteStorageEntity = {
    name: "remote-storage",
    api: {
        path: "/secure/remoteStorage",
        cacheName: "remoteStorage",
        defaultOrders: [{ by: "id", descending: true }],
    },
};

function useRemoteStorageDeleteValue(identifier, options) {
    return useGenericRequest({
        url: remoteStorageEntity.api.path + "/deleteValue?identifier=" + encodeURIComponent(identifier),
        method: "DELETE",
    }, {
        manual: true,
        clearCache: true,
        cacheName: remoteStorageEntity.api.cacheName,
        resultTransformer: function (responseData) { return responseData.success; },
    });
}

function useRemoteStorageSetValue(identifier, value, options) {
    if (options === void 0) { options = {
        encrypt: false,
    }; }
    return useGenericRequest({
        url: remoteStorageEntity.api.path + "/setValue?identifier=" + encodeURIComponent(identifier) + "&value=" + encodeURIComponent(value),
        method: "POST",
    }, {
        manual: true,
        clearCache: true,
        cacheName: remoteStorageEntity.api.cacheName,
        encrypt: options === null || options === void 0 ? void 0 : options.encrypt,
    });
}

function useRemoteStorageGetValues(filter, options) {
    if (options === void 0) { options = {
        manual: false,
        cache: false,
        throttle: false,
        encrypt: false,
    }; }
    return useGenericRequest({
        url: remoteStorageEntity.api.path + "/getValues",
        method: "POST",
        data: filter || {},
    }, {
        manual: options === null || options === void 0 ? void 0 : options.manual,
        cache: options === null || options === void 0 ? void 0 : options.cache,
        cacheName: remoteStorageEntity.api.cacheName,
        throttle: options === null || options === void 0 ? void 0 : options.throttle,
        encrypt: options === null || options === void 0 ? void 0 : options.encrypt,
    });
}

var RemoteStorageContext = React__default["default"].createContext(undefined);
var RemoteStorageProvider = function (_a) {
    var loggedIn = _a.loggedIn, _b = _a.autoRefresh, autoRefresh = _b === void 0 ? true : _b, _c = _a.refreshInterval, refreshInterval = _c === void 0 ? 1800000 : _c, children = _a.children;
    var _d = useLocalStorageState(PARAM_REMOTE_STORAGE_LAST_UPDATE_TIME, 0), lastUpdateTime = _d[0], setLastUpdateTime = _d[1];
    var _e = useLocalStorageState(PARAM_REMOTE_STORAGE_VALUES, null), values = _e[0], setValues = _e[1];
    var _f = React.useState(0), refreshFlag = _f[0], setRefreshFlag = _f[1];
    var initialized = React.useMemo(function () { return lastUpdateTime > 0; }, [lastUpdateTime]);
    var _g = useLocalStorageState(PARAM_REMOTE_STORAGE_VALUES_TO_SAVE, []), valuesToSave = _g[0], setValuesToSave = _g[1];
    var _h = React.useState(null), selectedValueToSave = _h[0], setSelectedValueToSave = _h[1];
    var _j = useLocalStorageState(PARAM_REMOTE_STORAGE_IDENTIFIERS_TO_DELETE, []), identifiersToDelete = _j[0], setIdentifiersToDelete = _j[1];
    var _k = React.useState(null), selectedIdentifierToDelete = _k[0], setSelectedIdentifierToDelete = _k[1];
    var getValuesState = useRemoteStorageGetValues(undefined, {
        cache: false,
        manual: true,
        throttle: true,
        encrypt: false,
    });
    var getValuesRequestTime = React.useRef(0);
    var saveState = useRemoteStorageSetValue((selectedValueToSave === null || selectedValueToSave === void 0 ? void 0 : selectedValueToSave.identifier) || "", (selectedValueToSave === null || selectedValueToSave === void 0 ? void 0 : selectedValueToSave.value) || "");
    var deleteState = useRemoteStorageDeleteValue(selectedIdentifierToDelete || "");
    React.useEffect(function () {
        if (!loggedIn) {
            setLastUpdateTime(0);
            setValues(null);
            setValuesToSave([]);
            setSelectedValueToSave(null);
            setIdentifiersToDelete([]);
            setSelectedIdentifierToDelete(null);
            getValuesRequestTime.current = 0;
        }
    }, [loggedIn]);
    React.useEffect(function () {
        if (loggedIn && !getValuesState.loading) {
            var now = new Date().getTime();
            if (now - lastUpdateTime > 60000) {
                getValuesState.executeRequest();
                getValuesRequestTime.current = now;
            }
        }
    }, [loggedIn, refreshFlag]);
    React.useEffect(function () {
        if (!autoRefresh) {
            return;
        }
        var interval = setInterval(function () {
            setRefreshFlag(function (currentRefreshFlag) { return currentRefreshFlag + 1; });
        }, refreshInterval);
        return function () {
            clearInterval(interval);
        };
    }, []);
    React.useEffect(function () {
        var resultValues = getValuesState.result;
        if (resultValues) {
            var now_1 = new Date().getTime();
            setLastUpdateTime(now_1);
            setValues(function (currentValues) {
                var recentClientChanges = (currentValues || []).filter(function (v) { return v.updateTime > getValuesRequestTime.current; });
                recentClientChanges.forEach(function (recentClientChange) {
                    ___default["default"].remove(resultValues, function (v) { return v.identifier === recentClientChange.identifier; });
                });
                return __spreadArray(__spreadArray([], recentClientChanges, true), resultValues.map(function (dto) { return (__assign(__assign({}, dto), { updateTime: now_1 })); }));
            });
        }
    }, [getValuesState.result]);
    React.useEffect(function () {
        var savedValue = saveState.result;
        if (savedValue) {
            setValuesToSave(function (currentValuesToSave) {
                // If the value is different it means there is a later update to this identifier and we should not remove it.
                return currentValuesToSave.filter(function (v) { return v.identifier !== savedValue.identifier || v.value !== savedValue.value; });
            });
        }
    }, [saveState.result]);
    React.useEffect(function () {
        if (saveState.loading) {
            return;
        }
        var selectedValueToSave = ___default["default"].first(valuesToSave);
        if (selectedValueToSave) {
            setSelectedValueToSave(selectedValueToSave);
        }
    }, [valuesToSave]);
    React.useEffect(function () {
        if (selectedValueToSave) {
            saveState.executeRequest();
        }
    }, [selectedValueToSave]);
    React.useEffect(function () {
        if (deleteState.loading) {
            return;
        }
        var selectedIdentifierToDelete = ___default["default"].first(identifiersToDelete);
        if (selectedIdentifierToDelete) {
            setSelectedIdentifierToDelete(selectedIdentifierToDelete);
        }
    }, [identifiersToDelete, deleteState.result]);
    React.useEffect(function () {
        if (selectedIdentifierToDelete) {
            deleteState.executeRequest();
        }
    }, [selectedIdentifierToDelete]);
    React.useEffect(function () {
        if (deleteState.result && selectedIdentifierToDelete) {
            setIdentifiersToDelete(function (currentIdentifiersToDelete) {
                return currentIdentifiersToDelete.filter(function (i) { return i !== selectedIdentifierToDelete; });
            });
        }
    }, [deleteState.result]);
    var getValue = React.useCallback(function (identifier) {
        if (!loggedIn) {
            return null;
        }
        var remoteStorageValue = ___default["default"].find(values, { identifier: identifier });
        return (remoteStorageValue === null || remoteStorageValue === void 0 ? void 0 : remoteStorageValue.value) ? JSON.parse(remoteStorageValue.value) : null;
    }, [values, loggedIn]);
    var deleteValue = React.useCallback(function (identifier) {
        if (!loggedIn) {
            return;
        }
        setValues(function (currentValues) { return (currentValues || []).filter(function (value) { return value.identifier !== identifier; }); });
        setIdentifiersToDelete(function (currentIdentifiersToDelete) { return __spreadArray(__spreadArray([], currentIdentifiersToDelete.filter(function (i) { return i !== identifier; }), true), [
            identifier,
        ]); });
    }, [loggedIn, setValues, setIdentifiersToDelete]);
    var setValue = React.useCallback(function (identifier, value) {
        if (!loggedIn) {
            return;
        }
        if (___default["default"].isNil(value)) {
            deleteValue(identifier);
            return;
        }
        var valueString = JSON.stringify(value);
        var now = new Date().getTime();
        setValues(function (currentValues) { return __spreadArray(__spreadArray([], (currentValues || []).filter(function (v) { return v.identifier !== identifier; }), true), [
            { identifier: identifier, value: valueString, updateTime: now },
        ]); });
        setValuesToSave(function (currentValuesToSave) { return __spreadArray(__spreadArray([], currentValuesToSave.filter(function (v) { return v.identifier !== identifier; }), true), [
            { identifier: identifier, value: valueString },
        ]); });
    }, [values, loggedIn, deleteValue, setValues, setValuesToSave]);
    return (React__default["default"].createElement(RemoteStorageContext.Provider, { value: { initialized: initialized, lastUpdateTime: lastUpdateTime, getValue: getValue, setValue: setValue, deleteValue: deleteValue } }, children));
};

var useRemoteStorage = function () {
    var context = React.useContext(RemoteStorageContext);
    if (!context)
        throw new Error("RemoteStorageContext must be used inside RemoteStorageProvider");
    return context;
};

var Fingerprint = {
    getFingerprint: function () {
        return __awaiter(this, void 0, void 0, function () {
            var fingerprint;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fingerprint = LocalStorageWrapper.get(PARAM_FINGERPRINT);
                        if (!!fingerprint) {
                            return [2 /*return*/, fingerprint];
                        }
                        return [4 /*yield*/, new Promise(function (success, fail) {
                                var options = {
                                    excludes: {
                                        // Commented out because we save the fingerprint in the local storage
                                        // screenResolution: true,
                                        // availableScreenResolution: true,
                                        // hasLiedResolution: true,
                                        enumerateDevices: true,
                                        pixelRatio: true,
                                        doNotTrack: true,
                                        fontsFlash: true,
                                        // platform: true
                                    },
                                };
                                Fingerprint2__default["default"].get(options, function (components) {
                                    var values = components.map(function (component) {
                                        return component.value;
                                    });
                                    var murmur = Fingerprint2__default["default"].x64hash128(values.join(""), 31);
                                    success(murmur);
                                });
                            })
                                .then(function (response) { return response; })
                                .catch(function (error) { return error; })];
                    case 1:
                        fingerprint = _a.sent();
                        LocalStorageWrapper.set(PARAM_FINGERPRINT, fingerprint);
                        return [2 /*return*/, fingerprint];
                }
            });
        });
    },
    getFingerprintSync: function () {
        return LocalStorageWrapper.get(PARAM_FINGERPRINT) || undefined;
    },
};

var findValues = function (obj, key) {
    return findValuesHelper(obj, key, []);
};
function findValuesHelper(obj, key, list) {
    if (!obj)
        return list;
    if (obj instanceof Array) {
        for (var i in obj) {
            list = list.concat(findValuesHelper(obj[i], key, []));
        }
        return list;
    }
    if (obj[key])
        list.push(obj[key]);
    if (typeof obj == "object") {
        var children = Object.keys(obj);
        if (children.length > 0) {
            for (var i = 0; i < children.length; i++) {
                list = list.concat(findValuesHelper(obj[children[i]], key, []));
            }
        }
    }
    return list;
}
var notEmpty = function (value) {
    if (value === null || value === undefined)
        return false;
    return true;
};
var typeCheck = function (arg) {
    return arg;
};

var URL_PARAM_UPDATE_PACK = "up";

var UpdatePackUtils = {
    addUpdatePack: function (updatePack) {
        var _a;
        var id = uuid.v4().substr(0, 8);
        LocalStorageWrapper.set(PARAM_UPDATE_PACKS, (_a = {},
            _a[id] = updatePack,
            _a));
        return id;
    },
    popUpdatePack: function (id) {
        var updatePacks = LocalStorageWrapper.get(PARAM_UPDATE_PACKS) || {};
        LocalStorageWrapper.remove(PARAM_UPDATE_PACKS);
        return updatePacks[id];
    },
    getUpdatePackUrlParam: function () {
        return URL_PARAM_UPDATE_PACK;
    },
};

var buildUrl = function (url, options) {
    if (!options) {
        return url;
    }
    var origin = window.location.origin;
    var urlObject = new URL(url, origin);
    ___default["default"].forEach(options === null || options === void 0 ? void 0 : options.queryStringParams, function (value, key) {
        urlObject.searchParams.append(key, value);
    });
    url = urlObject.href;
    if (!options.withOrigin) {
        url = url.replace(origin, "");
    }
    return url;
};
var getUrlParams = function () {
    var result = {};
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.forEach(function (value, key) {
        result[key] = value;
    });
    return result;
};
var getUrlParam = function (key, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ""; }
    var searchParams = new URLSearchParams(window.location.search);
    var value = searchParams.get(key);
    return value || defaultValue;
};
var setUrlParams = function (params, addToHistory) {
    if (addToHistory === void 0) { addToHistory = false; }
    var currentParams = getUrlParams();
    if (___default["default"].isEqualWith(currentParams, params, function (x, y) { return x == y; })) {
        return;
    }
    updateQuerystring(getUrlParamsQuerystring(params), addToHistory);
};
var addUrlParams = function (params, addToHistory) {
    if (addToHistory === void 0) { addToHistory = false; }
    var currentParams = getUrlParams();
    if (___default["default"].isMatchWith(currentParams, params, function (x, y) { return x == y; })) {
        return;
    }
    updateQuerystring(getUrlParamsQuerystring(___default["default"].merge(getUrlParams(), params)), addToHistory);
};
var removeUrlParam = function (param, addToHistory) {
    if (addToHistory === void 0) { addToHistory = false; }
    var params = getUrlParams();
    if (!___default["default"].has(params, param)) {
        return;
    }
    ___default["default"].unset(params, param);
    updateQuerystring(getUrlParamsQuerystring(params), addToHistory);
};
var getUrlParamsQuerystring = function (params) {
    var searchParams = new URLSearchParams();
    if (params) {
        ___default["default"].forEach(params, function (value, key) {
            searchParams.set(key, value);
        });
    }
    return searchParams.toString();
};
var updateQuerystring = function (querystring, addToHistory) {
    var url = querystring ? "?" + querystring : document.location.href.split("?")[0];
    if (addToHistory) {
        window.history.pushState(null, "", url);
    }
    else {
        window.history.replaceState(null, "", url);
    }
};

var useDebounceFn = function (fn, wait) {
    var fnDebounced = React.useCallback(___default["default"].debounce(fn, wait), []);
    reactUse.useUnmount(function () {
        fnDebounced.cancel();
    });
    return fnDebounced;
};

var useItemIdUrlState = function (generateUrlFn) {
    var params = reactRouterDom.useParams();
    var getUrlId = function () {
        return parseInt(params.id || "0");
    };
    var _a = React.useState(getUrlId()), itemId = _a[0], setItemId = _a[1];
    // When the item is saved we update the url to the new item id so it will show on refresh.
    reactUse.useUpdateEffect(function () {
        if (getUrlId() === 0 && itemId > 0) {
            var newUrl = generateUrlFn(itemId);
            if (newUrl.indexOf("?") < 0) {
                var querystring = window.location.search || "";
                newUrl += querystring;
            }
            window.history.replaceState({}, "", newUrl);
        }
    }, [itemId]);
    return [itemId, setItemId];
};

var useUrlState = function (urlParam, defaultValue, shouldSaveState, stateParser, stateStringify, addToHistory) {
    if (shouldSaveState === void 0) { shouldSaveState = null; }
    if (stateParser === void 0) { stateParser = null; }
    if (stateStringify === void 0) { stateStringify = null; }
    if (addToHistory === void 0) { addToHistory = false; }
    var pathname = React.useState(window.location.pathname)[0];
    var getInitialState = function () {
        var urlParamValue = getUrlParam(urlParam, "");
        if (urlParamValue && stateParser) {
            return stateParser(urlParamValue) || defaultValue;
        }
        return defaultValue;
    };
    var _a = React.useState(getInitialState()), state = _a[0], setState = _a[1];
    var shouldSaveStateInternal = function (state) {
        if (shouldSaveState) {
            return shouldSaveState(state);
        }
        return !!state;
    };
    React.useEffect(function () {
        var _a;
        if (state && shouldSaveStateInternal(state)) {
            var paramValue = stateStringify ? stateStringify(state) : ___default["default"].toString(state);
            addUrlParams((_a = {}, _a[urlParam] = paramValue, _a), addToHistory);
        }
        else {
            removeUrlParam(urlParam, addToHistory);
        }
        return function () {
            if (___default["default"].isEqual(pathname, window.location.pathname) && !!getUrlParam(urlParam)) {
                removeUrlParam(urlParam, false);
            }
        };
    }, [state]);
    return [state, setState];
};

var useUrlStateString = function (urlParam, defaultValue, shouldSaveState, stateParser, stateStringify, addToHistory) {
    if (defaultValue === void 0) { defaultValue = null; }
    if (shouldSaveState === void 0) { shouldSaveState = null; }
    if (stateParser === void 0) { stateParser = null; }
    if (stateStringify === void 0) { stateStringify = null; }
    if (addToHistory === void 0) { addToHistory = false; }
    return useUrlState(urlParam, defaultValue, shouldSaveState, stateParser || (function (urlState) { return urlState; }), stateStringify || (function (state) { return state || ""; }), addToHistory);
};

var useItemDetailsState = function (entity, generateEmptyItem, generateUrlFn) {
    var _a = useItemIdUrlState(generateUrlFn), itemId = _a[0], setItemId = _a[1];
    var _b = React.useState({}), initialValue = _b[0], setInitialValue = _b[1];
    var _c = useUrlStateString(URL_PARAM_UPDATE_PACK), updatePackId = _c[0], setUpdatePackId = _c[1];
    var _d = React.useState(undefined), dataItem = _d[0], setDataItem = _d[1];
    var saveState = useCrudCreateOrUpdate(entity, dataItem);
    var _e = React.useState(false), saving = _e[0], setSaving = _e[1];
    var _f = React.useState(false), hasChanges = _f[0], setHasChanges = _f[1];
    var lastChangeTime = React.useRef(0);
    var lastSaveTime = React.useRef(0);
    var _g = React.useState(0), saveMillis = _g[0], setSaveMillis = _g[1];
    var saveDebounced = useDebounceFn(setSaveMillis, 2500);
    var _h = React.useState(undefined), item = _h[0], setItemInternal = _h[1];
    var setItem = React.useCallback(function (updatedItem) {
        if (updatePackId) {
            var updatePack = UpdatePackUtils.popUpdatePack(updatePackId);
            setUpdatePackId("");
            if (updatePack) {
                updatedItem = ___default["default"].merge({}, updatedItem, updatePack);
                if (!!updatedItem.id) {
                    saveItem();
                }
            }
        }
        if (!item) {
            setInitialValue(updatedItem);
        }
        setItemInternal(function (item) {
            if (!item || !updatedItem) {
                return updatedItem;
            }
            else {
                return __assign(__assign({}, item), updatedItem);
            }
        });
    }, [item, setItemInternal, updatePackId, setUpdatePackId, setDataItem]);
    var editable = true;
    var showState = useCrudShow(entity, itemId, { manual: true });
    var _j = React.useState(0), refresh = _j[0], setRefresh = _j[1];
    React.useEffect(function () {
        if (itemId && (!item || item.id !== itemId)) {
            showState.executeRequest();
        }
        if (!itemId && generateEmptyItem) {
            setItem(___default["default"].merge({ uniqueKey: uuid.v4() }, generateEmptyItem()));
        }
    }, [itemId]);
    reactUse.useUpdateEffect(function () {
        if (itemId) {
            showState.executeRequest();
        }
    }, [refresh]);
    var refreshItem = React.useCallback(function () {
        setRefresh(function (refresh) { return refresh + 1; });
    }, []);
    React.useEffect(function () {
        if (showState && showState.result) {
            setItem(___default["default"].merge({ uniqueKey: uuid.v4() }, showState.result));
        }
    }, [showState.result]);
    React.useEffect(function () {
        if (dataItem) {
            setSaving(true);
            lastSaveTime.current = new Date().getTime();
            saveState.executeRequest();
        }
    }, [dataItem]);
    React.useEffect(function () {
        if (saveState && saveState.result) {
            var hasChanges_1 = lastChangeTime.current > lastSaveTime.current;
            if (!item || item.id !== saveState.result.id || !hasChanges_1) {
                setItem(saveState.result);
                setItemId(saveState.result.id);
            }
            setSaving(false);
            setHasChanges(hasChanges_1);
        }
    }, [saveState.result]);
    React.useEffect(function () {
        if (saveState && saveState.error) {
            setSaving(false);
        }
    }, [saveState.error]);
    var saveItem = function () {
        var now = new Date().getTime();
        setSaveMillis(now);
        saveDebounced(now);
    };
    React.useEffect(function () {
        if (item && editable && saveMillis) {
            saveDebounced(0);
            setDataItem(___default["default"].merge({}, item));
        }
    }, [saveMillis]);
    var updateItem = React.useCallback(function (itemData, debounced) {
        if (debounced === void 0) { debounced = true; }
        setItem(___default["default"].mergeWith({}, item, itemData, function (objValue, srcValue) {
            if (___default["default"].isArray(srcValue)) {
                return srcValue;
            }
        }));
        var now = new Date().getTime();
        setHasChanges(true);
        lastChangeTime.current = now;
        if (debounced) {
            saveDebounced(now);
        }
        else {
            setSaveMillis(now);
        }
    }, [setItem, setHasChanges, saveDebounced, setSaveMillis]);
    return {
        initialValue: initialValue,
        item: item,
        setItem: setItem,
        itemId: itemId,
        editable: editable,
        loading: showState.loading,
        saving: saving,
        hasChanges: hasChanges,
        saveItem: saveItem,
        updateItem: updateItem,
        refreshItem: refreshItem,
    };
};

var usePagination = function (items, pageSize) {
    if (pageSize === void 0) { pageSize = 50; }
    var _a = React.useState([]), pageItems = _a[0], setPageItems = _a[1];
    var _b = React.useState(1), currentPage = _b[0], setCurrentPage = _b[1];
    var _c = React.useState(1), totalPages = _c[0], setTotalPages = _c[1];
    React.useEffect(function () {
        if (items) {
            setTotalPages(Math.max(Math.ceil(items.length / pageSize), 1));
        }
    }, [items]);
    React.useEffect(function () {
        if (items) {
            var startIndex = (currentPage - 1) * pageSize;
            var endIndex = startIndex + pageSize;
            setPageItems(items.slice(startIndex, endIndex));
        }
    }, [items, currentPage]);
    React.useEffect(function () {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    }, [totalPages]);
    return [{ pageItems: pageItems, currentPage: currentPage, totalPages: totalPages, pageSize: pageSize }, setCurrentPage];
};

var useScript = function (url) {
    React.useEffect(function () {
        var script = document.createElement("script");
        script.src = url;
        script.async = true;
        document.body.appendChild(script);
        return function () {
            document.body.removeChild(script);
        };
    }, [url]);
};

exports.EncryptionUtils = EncryptionUtils;
exports.Fingerprint = Fingerprint;
exports.LocalStorageWrapper = LocalStorageWrapper;
exports.RemoteStorageContext = RemoteStorageContext;
exports.RemoteStorageProvider = RemoteStorageProvider;
exports.UpdatePackUtils = UpdatePackUtils;
exports.addUrlParams = addUrlParams;
exports.buildUrl = buildUrl;
exports.cacheAdapterEnhancer = cacheAdapterEnhancer;
exports.encryptionAdapterEnhancer = encryptionAdapterEnhancer;
exports.findValues = findValues;
exports.getUrlParam = getUrlParam;
exports.getUrlParams = getUrlParams;
exports.getUrlParamsQuerystring = getUrlParamsQuerystring;
exports.notEmpty = notEmpty;
exports.removeUrlParam = removeUrlParam;
exports.setUrlParams = setUrlParams;
exports.throttleAdapterEnhancer = throttleAdapterEnhancer;
exports.typeCheck = typeCheck;
exports.updateQuerystring = updateQuerystring;
exports.useCrudCreate = useCrudCreate;
exports.useCrudCreateMany = useCrudCreateMany;
exports.useCrudCreateOrUpdate = useCrudCreateOrUpdate;
exports.useCrudCreateOrUpdateMany = useCrudCreateOrUpdateMany;
exports.useCrudDelete = useCrudDelete;
exports.useCrudDeleteMany = useCrudDeleteMany;
exports.useCrudSearch = useCrudSearch;
exports.useCrudSearchCount = useCrudSearchCount;
exports.useCrudShow = useCrudShow;
exports.useCrudUpdate = useCrudUpdate;
exports.useCrudUpdateMany = useCrudUpdateMany;
exports.useDebounceFn = useDebounceFn;
exports.useGenericRequest = useGenericRequest;
exports.useGenericRequestMany = useGenericRequestMany;
exports.useGenericRequestUpload = useGenericRequestUpload;
exports.useItemDetailsState = useItemDetailsState;
exports.useItemIdUrlState = useItemIdUrlState;
exports.useLocalStorageState = useLocalStorageState;
exports.useMediaFileDeleteEntity = useMediaFileDeleteEntity;
exports.useMediaFileDownload = useMediaFileDownload;
exports.useMediaFileUpload = useMediaFileUpload;
exports.useMediaFileUploadEntity = useMediaFileUploadEntity;
exports.usePagination = usePagination;
exports.useRemoteStorage = useRemoteStorage;
exports.useScript = useScript;
exports.useUrlState = useUrlState;
exports.useUrlStateString = useUrlStateString;
//# sourceMappingURL=index.js.map
